<template>
    <div>
        <h2>Resumo:</h2>
        
        <ul>
            <li>O Pedido Rápido é um sistema gratuito, com funcionalidades adicionais pagas.</li>
            <li>Seus dados, como suas vendas e faturamento não serão publicados. Porém, podem ser usados para aprimorar a experiência do sistema como também em relatórios gerais e não nominais.</li>
            <li>O plano gratuito do Pedido Rápido possui suporte limitado apenas a e-mail durante horário comercial.</li>
            <li>Não nos responsabilizamos por mau uso do sistema ou comprometimento de segurança devido à má gestão (como vazamentos de senhas por parte do cliente).</li>  
        </ul>
        
        <h2>Termos completos:</h2>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>